import GtDialog from './src/index';

export default GtDialog;
